import { CSSProperties, ReactNode, useRef, useState } from 'react';
import { StickyDetailHeader } from './sticky-detail-header';
import styles from './detail-page-with-sticky-header.module.css';

export interface DetailPageWithStickyHeaderProps {
    title?: string;
    subtitle?: string;
    /* Renders subtitle next to the title instead of stacked below it. */
    inlineSubtitle?: boolean;
    imageUrl?: string;
    renderActions?: () => ReactNode;
    banner: ReactNode;
    children?: ReactNode;
}

export function DetailPageWithStickyHeader({
    title,
    subtitle,
    inlineSubtitle,
    imageUrl,
    renderActions,
    banner,
    children,
}: DetailPageWithStickyHeaderProps) {
    const bannerRef = useRef<HTMLDivElement>(null);
    const [stickyBarHeight, setStickyBarHeight] = useState('0px');

    return (
        <div
            className={styles['detail-page-with-sticky-header']}
            style={{ '--sticky-bar-height': stickyBarHeight } as CSSProperties}
        >
            <div ref={bannerRef}>{banner}</div>
            <StickyDetailHeader
                targetRef={bannerRef}
                title={title}
                subtitle={subtitle}
                inlineSubtitle={inlineSubtitle}
                imageUrl={imageUrl}
                renderActions={renderActions}
                onStickyBarHeightChange={setStickyBarHeight}
            />
            {children}
        </div>
    );
}
